'use client';
import { xref } from '@s7/styles';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var xrefIcon = xref("viewSpec", "icon");
var getDisabledStyles = function(param) {
    var _param_palette = param.palette, border = _param_palette.border, background = _param_palette.background, text = _param_palette.text;
    var _obj;
    return _obj = {
        cursor: "not-allowed",
        borderColor: border.element,
        backgroundColor: background.highlight,
        "&:checked": {
            backgroundColor: border.divider,
            borderColor: "transparent"
        }
    }, _obj["& + ." + xrefIcon] = {
        color: text.tertiary
    }, _obj;
};
var getLabelStyles = function(param, shades, duration) {
    var text = param.palette.text, transition = param.fn.transition;
    return _extends({}, transition({
        props: "color",
        duration: duration
    }), {
        "&[data-error=true]": {
            color: shades.base
        },
        "&[data-disabled=true]": {
            color: text.secondary
        }
    });
};
var getShades = function(theme, params) {
    var _theme_fn = theme.fn, deriveShades = _theme_fn.deriveShades, themeColor = _theme_fn.themeColor;
    var _theme_palette = theme.palette, disruption = _theme_palette.disruption, primary = _theme_palette.primary;
    var error = params.error, color = params.color;
    if (color) {
        var shades = deriveShades(themeColor(color));
        return {
            mid: shades.mid || shades[200],
            base: shades.base || shades[600],
            big: shades.big || shades[800]
        };
    }
    if (error) {
        return disruption;
    }
    return primary;
};
var getViewSpec = function(theme, params, size, borderRadius) {
    var transitionDuration = params.transitionDuration, error = params.error;
    var _theme_fn = theme.fn, foreground = _theme_fn.foreground, transition = _theme_fn.transition, square = _theme_fn.square, border = _theme_fn.border, focusRing = _theme_fn.focusRing;
    var text = theme.palette.text;
    var shades = getShades(theme, params);
    var disabledStyles = getDisabledStyles(theme);
    var borderStyles = border({
        color: shades.big,
        width: 1
    });
    var _obj;
    return {
        inner: {
            display: "flex",
            position: "relative"
        },
        label: getLabelStyles(theme, shades, transitionDuration),
        icon: _extends({
            ref: xrefIcon,
            color: foreground(shades.base) === "dark" ? text.inverted : text.onColor,
            "&:disabled": {
                color: text.tertiary
            }
        }, transition({
            props: "opacity, color, transform",
            duration: transitionDuration
        })),
        input: _extends({
            boxSizing: "border-box",
            cursor: "pointer"
        }, transition({
            props: "background-color, border-color, box-shadow",
            duration: transitionDuration
        }), focusRing({
            color: shades.mid,
            styles: borderStyles
        }), border({
            color: error ? shades.base : text.tertiary,
            width: 1
        }), {
            backgroundColor: "transparent",
            "&:active": borderStyles,
            "&:hover": borderStyles,
            "&:checked": _extends({
                backgroundColor: shades.base
            }, border({
                color: shades.base,
                width: 1
            }), (_obj = {}, _obj["& + ." + xrefIcon] = {
                opacity: 1,
                transform: "scale(1)"
            }, _obj["&:hover"] = _extends({
                backgroundColor: shades.big
            }, borderStyles), _obj))
        }, square({
            size: size,
            radius: borderRadius
        }), {
            "&[readonly]": _extends({}, disabledStyles, {
                pointerEvents: "none",
                userSelect: "none",
                "&:focus": {
                    visibility: "hidden"
                }
            }),
            "&:disabled": disabledStyles
        })
    };
};

export { getViewSpec };
